import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["value", "onValueChange", "children", "isRemovable"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { useMemo, useRef } from 'react';
import { useRefCallback } from '@tencent/glue-react-use';
import { Upload } from '../../../Upload';
import { ImagePanel } from '../MaterialPanel/ImagePanel/ImagePanel';
import { UploadStatus } from '../MaterialUpload/type/interface';
export var SingleImageUpload = function SingleImageUpload(props) {
  var value = props.value,
    onValueChange = props.onValueChange,
    children = props.children,
    isRemovable = props.isRemovable,
    panelProps = _objectWithoutProperties(props, _excluded);
  var ref = useRef(null);
  var materialValue = useMemo(function () {
    if (!value) {
      return [];
    }
    return [value];
  }, [value]);
  var materialValueChange = useRefCallback(function (val) {
    onValueChange(val[0]);
  });
  var onRemove = useRefCallback(function () {
    onValueChange(null);
  });
  var cardStatus = (value === null || value === void 0 ? void 0 : value.imageUrl) ? UploadStatus.SUCCESS : UploadStatus.DEFAULT;
  return React.createElement(ImagePanel, _objectSpread(_objectSpread({}, panelProps), {}, {
    ref: ref,
    value: materialValue,
    onValueChange: materialValueChange
  }), typeof children === 'function' ? children({
    triggerUpload: function triggerUpload() {
      var _a;
      return (_a = ref.current) === null || _a === void 0 ? void 0 : _a.uploadImage(0);
    },
    value: value
  }) : React.createElement(Upload.Card, {
    status: cardStatus,
    value: value === null || value === void 0 ? void 0 : value.imageUrl,
    isReplaceable: true,
    isRemovable: isRemovable,
    onRemove: onRemove,
    onReplace: function onReplace() {
      var _a;
      return (_a = ref.current) === null || _a === void 0 ? void 0 : _a.uploadImage(0);
    },
    onClick: function onClick() {
      var _a;
      return (_a = ref.current) === null || _a === void 0 ? void 0 : _a.uploadImage(0);
    }
  }));
};